import { createSelector } from '@reduxjs/toolkit';

import { getLoggedInUser } from './users';

export const isG2User = createSelector(
  getLoggedInUser,
  (user) =>
    window.location.href.toString().includes('g2.') ||
    window.location.href.toString().includes('design.g2softwaresuite.com') ||
    user?.organization === 'G2 National',
);

export const isTrussWorksUser = createSelector(
  getLoggedInUser,
  (user) => window.location.href.toString().includes('trussworks.') || user?.organization === 'TrussWorks',
);

export const isDemoOrganizationUser = createSelector(
  getLoggedInUser,
  (user) => window.location.href.toString().includes('demo.') || user?.organization === 'Demo Organization',
);

export const isChMachineUser = createSelector(
  getLoggedInUser,
  (user) =>
    user?.organization === 'CH Machine' ||
    user?.organization === 'CH Machine DEMO' ||
    user?.organization === 'Truss Components of Atlanta' ||
    user?.organization === 'HardPine Inc.' ||
    user?.organization === 'Barden Building Products',
);

const whiteLabelDomains: readonly string[] = [];
export const isWhiteLabeledParagonUser = () =>
  whiteLabelDomains.some((whiteLabelDomain) => window.location.href.toString().includes(whiteLabelDomain));

export const isUsingCustomTheme = createSelector(
  isChMachineUser,
  isDemoOrganizationUser,
  isTrussWorksUser,
  isG2User,
  (isChMachineUser, isDemoOrganizationUser, isTrussWorksUser, isG2User) =>
    isChMachineUser || isDemoOrganizationUser || isTrussWorksUser || isG2User,
);
